


















import {
  defineComponent, PropType, ref, useContext,
} from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import { getBase64EncodedProductPdf } from '~/modules/pdfDownload/getters/product';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'PdfDownloadProduct',
  components: {
    SfButton,
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
  },
  setup(props) {
    const { app } = useContext();
    const context = app.$vsf;
    const response = ref();

    const downloadPdf = async () => {
      response.value = await getBase64EncodedProductPdf.execute(context, props.product.sku);
      if (!response.value?.productPdf?.response) return;

      const linkSource = `data:image/png;base64,${response.value.productPdf.response}`;
      const downloadLink = document.createElement('a');
      const fileName = response.value.productPdf.file_name;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    };

    return {
      downloadPdf,
    };
  },
});
